import { render, staticRenderFns } from "./WxDateRangePicker.vue?vue&type=template&id=745f1beb&scoped=true"
import script from "./WxDateRangePicker.vue?vue&type=script&lang=js"
export * from "./WxDateRangePicker.vue?vue&type=script&lang=js"
import style0 from "./WxDateRangePicker.vue?vue&type=style&index=0&id=745f1beb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f1beb",
  null
  
)

export default component.exports